// Keyboard/screen-reader affordance: a visually-hidden link that becomes
// visible on focus, letting users jump past the nav straight to main content.
export default function SkipLink({ href = "#main-content", children = "Skip to content" }) {
  return (
    <a
      href={href}
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:rounded-full focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-black focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#4f46e5]"
    >
      {children}
    </a>
  );
}
